module.exports = __webpack_public_path__ + "img/icon_kapiao.10a71bfc.png";